import createRequestSaga from "../../../common/saga/createRequestSaga";
import { takeLatest } from "redux-saga/effects";
import * as updateUserApi from "../api/updateUserApi";
import { UPDATE_USER, MY_INFO, UPDATE_ADDRESS } from "../actionCreators";

const UpdateUserSaga = createRequestSaga(
  UPDATE_USER,
  updateUserApi.updateUserApi
);

const MyInfoSaga = createRequestSaga(MY_INFO, updateUserApi.myInfoApi);

const UpdateAddressSaga = createRequestSaga(
  UPDATE_ADDRESS,
  updateUserApi.updateAddressApi
);

export function* updateUserSaga() {
  yield takeLatest(UPDATE_USER, UpdateUserSaga);
  yield takeLatest(MY_INFO, MyInfoSaga);
  yield takeLatest(UPDATE_ADDRESS, UpdateAddressSaga);
}
